var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Vue, Component, Watch } from 'vue-property-decorator';
import { BContainer, BRow, BCol, BOverlay, BButton, BModal, VBModal, ModalPlugin, BFormGroup, BInputGroup, BInputGroupAppend, BFormInput, BFormRadioGroup, BAlert } from 'bootstrap-vue';
import { lightFormat } from 'date-fns';
import Item from './Item.vue';
import Enquiry from './Enquiry.vue';
import ShippingZones from './ShippingZones.vue';
import DiscountCodeSelector from './DiscountCodeSelector.vue';
import { emptyCart, getCart, processOrder, setCollection, setPostcode, setShippingZone } from 'ts/modules/cart';
import { isAdmin } from 'ts/modules/helpers';
Vue.use(ModalPlugin);
const now = new Date();
let Cart = class Cart extends Vue {
    constructor() {
        super(...arguments);
        this.cart = {
            id: 0,
            items: [],
            subtotal: "0.00",
            postage: "0.00",
            vat: "0.00",
            total: "0.00",
            selectedZone: 'Mainland UK',
            dueDate: { from: 0, to: 0 },
            discountCode: null
        };
        this.itemSubtotal = '1.00';
        this.postage = '0.00';
        this.VAT = '0.20';
        this.totalIncVAT = '1.20';
        this.discountCode = '';
        this.deliveryType = 'delivery';
        this.postcode = '';
        this.deliveryOptions = [
            { text: 'Delivery', value: 'delivery' },
            { text: 'Collection', value: 'collection' }
        ];
        this.loading = false;
        this.isAdmin = false;
    }
    get today() {
        return lightFormat(now, 'dd/MM/yyyy');
    }
    get isCheckoutEnabled() {
        return this.cart.items.length > 0 && this.areItemsInStock;
    }
    get checkoutBtnVariant() {
        return this.isCheckoutEnabled ? 'success' : 'danger';
    }
    get isDeliveryAvailable() {
        return this.cart.items.filter(item => !item.isDeliveryAvailable).length === 0;
    }
    get areItemsInStock() {
        return this.cart.items.filter(item => !item.inStock).length === 0;
    }
    onEnquirySend() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.$bvModal.msgBoxOk(`Successfully sent enquiry, we will get back to you as soon as possible from 9am - 5pm Monday to Friday`);
            this.$bvModal.hide('email-modal');
        });
    }
    refresh() {
        return __awaiter(this, void 0, void 0, function* () {
            this.loading = true;
            this.cart = yield getCart();
            if (this.cart.selectedZone == 'Collection'
                || this.cart.items.filter(item => !item.isDeliveryAvailable).length > 0) {
                console.log("Setting type to collection");
                this.deliveryType = 'collection';
            }
            this.loading = false;
        });
    }
    onDeliveryTypeChange() {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            console.log(this.deliveryType);
            if (this.deliveryType == 'delivery') {
                res = yield setShippingZone('Mainland UK');
            }
            else {
                // Set collection if appropriate
                res = yield setCollection();
            }
            if (res) {
                this.refresh();
            }
        });
    }
    setPostcode() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let res = yield setPostcode(this.postcode);
                if (res) {
                    this.refresh();
                }
            }
            catch (e) {
                this.$bvModal.msgBoxOk(`Unrecognised postcode, please check it is entered correctly.`);
            }
        });
    }
    emptyCart() {
        return __awaiter(this, void 0, void 0, function* () {
            let res = yield this.$bvModal.msgBoxConfirm(`Are you sure you want to empty your cart?`);
            if (res) {
                let status = yield emptyCart();
                if (status) {
                    this.refresh();
                }
            }
        });
    }
    processOrder() {
        return __awaiter(this, void 0, void 0, function* () {
            const processOrderRes = yield processOrder();
            window.open(processOrderRes.url, '_blank');
        });
    }
    mounted() {
        this.refresh();
    }
    created() {
        return __awaiter(this, void 0, void 0, function* () {
            this.isAdmin = yield isAdmin();
        });
    }
};
__decorate([
    Watch('deliveryType')
], Cart.prototype, "onDeliveryTypeChange", null);
Cart = __decorate([
    Component({
        components: {
            BContainer, BRow, BCol, BOverlay, BButton, BFormGroup, BFormInput, BFormRadioGroup, BModal, BInputGroup, BInputGroupAppend, BAlert,
            Item, Enquiry, ShippingZones, DiscountCodeSelector
        },
        directives: {
            "b-modal": VBModal
        }
    })
], Cart);
export default Cart;
